import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import Moment from 'react-moment';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class DonorAgeGender extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);

		this.getConvokePlace = this.getConvokePlace.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"all",
			health_facilities: [],

			convoke_places:[],
			convoke_places_id:"all",
			convoke_places_name:"",

			table_list:[],
			listado:[],
			start_date 	:"",
			end_date 	:"",
			
			change_check: false,

			//test datatable to export
			columns:[
				{title:'Determinación', width:'120px'},
				{title: 'Mujeres 18-24', width:'100px'},
				{title: 'Mujeres 25-44', width:'100px'},
				{title: 'Mujeres 45-65', width:'100px'},
				{title: 'Hombres 18-24', width:'100px'},
				{title: 'Hombres 25-44', width:'100px'},
				{title: 'Hombres 45-65', width:'100px'},
				{title: 'Mujeres Fuera de Rango', width:'150px'},
				{title: 'Hombres Fuera de Rango', width:'150px'},
				{title: 'Total Mujeres', width:'100px'},
				{title: 'Total Hombres', width:'100px'},
				{title: 'Total', width:'90px'},
			],
			filename:"Donantes Edad y Género",
			type:"",
			type_name:"",
			count:"",
			totales:[],
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})


		this.getConvokePlace();

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	setTable(){
 		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY");
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
               	{
                	extend: 'pdf',
                	title: this.state.filename,
                	pageSize: 'A4',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						var i_table = 3;
						if(this.state.convoke_places_id !== "all" || this.state.type !== ""){
							doc.content.splice(3, 0, {
								columns:[
									this.state.convoke_places_id !== "all" ?
										{text: 'Lugar de Colecta', width:'12%'}
									: {text:"", width:0},
									this.state.convoke_places_id !== "all" ?
										{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], width:'30%' }
									: {text:"", width:0},

									this.state.type !== "" ?
										{text: 'Estatus', width:'10%'}
									: {text:"", width:0},
									this.state.type !== "" ?
										{text: this.state.type_name, bold:1, margin:[0,0,0,10], width:'10%'}
									: {text:"", width:0},
								]
							});
							i_table = 4;
						}

            			doc.content[i_table].table.widths=["10%","8.5%","8.5%","8.5%","8.5%","8.5%","8.5%","8.5%","8.5%","8.5%", "8.5%", "5%"];
            			
            			doc.content[i_table].table.body.map((b, i)=>{
                			b.map((t, j)=>{
                				if(j > 0){
                					t.alignment = 'right';
                				}
                			})
                		})

                		doc.defaultStyle.fontSize = 7;
                		doc.styles.tableHeader.fontSize = 7;
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	}
            	}
            ],
			columnDefs: [{
		        targets: [1,2,3,4,5,6,7,8,9,10,11],
		        className: 'dt-right'
    		}],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:false,
			createdRow: function(row, data, dataIndex){
				if(data[0] === 'TOTAL'){
			        $('td', row).attr('style', 'text-align:right; font-weight:bold');
				}

				return row;
            }
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
			}, 500);
		}

		if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'type'){
			this.setState({
				type_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					convoke_places_id: this.state.convoke_places_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					option: this.state.type,
					health_facilities_id:this.state.health_facilities_id
				}

				if(this.state.type === 'GROUP_REJECT'){
					this.setState({
						columns:[
							{title: 'Categoria', width:'150px'},
							{title: 'Mujeres 18-24', width:'10px'},
							{title: 'Mujeres 25-44', width:'10px'},
							{title: 'Mujeres 45-65', width:'10px'},
							{title: 'Hombres 18-24', width:'10px'},
							{title: 'Hombres 25-44', width:'10px'},
							{title: 'Hombres 45-65', width:'10px'},
							{title: 'Mujeres Fuera de Rango', width:'220px'},
							{title: 'Hombres Fuera de Rango', width:'220px'},
							{title: 'Total Mujeres', width:'10px'},
							{title: 'Total Hombres', width:'10px'},
							{title: 'Total', width:'100px'},
						],
					})
				}else{
					this.setState({
						columns:[
							{title: 'Determinación', width:'100px'},
							{title: 'Mujeres 18-24', width:'100px'},
							{title: 'Mujeres 25-44', width:'100px'},
							{title: 'Mujeres 45-65', width:'100px'},
							{title: 'Hombres 18-24', width:'100px'},
							{title: 'Hombres 25-44', width:'100px'},
							{title: 'Hombres 45-65', width:'100px'},
							{title: 'Mujeres Fuera de Rango', width:'150px'},
							{title: 'Hombres Fuera de Rango', width:'150px'},
							{title: 'Total Mujeres', width:'100px'},
							{title: 'Total Hombres', width:'100px'},
							{title: 'Total', width:'100px'},
						],
					})
				}
				
				fetch(Config.default.apiGateway.URL+'reports/donors_stats_reject',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
				
				if(response !== undefined){
					this.setState({
						listado: [],
					});

					var list = [];
					
					response.res.map((r)=>{
						var row = [];
						
						row.push(
							r.reason, 
							r.w_18_24,
							r.w_25_44,
							r.w_45_65,
							r.m_18_24,
							r.m_25_44,
							r.m_45_65,
							r.w_out_range,
							r.m_out_range,
							r.tot_M,
							r.tot_H
						);

						var total = r.tot_H+r.tot_M

						row.push(total);

						if(this.state.type === 'GROUP_REJECT'){
							row.splice(0, 1, r.category);
						}

						return list.push(row);
					});

					var totals = [];
					totals.push(
						'TOTAL',
						response.totals.w_18_24_total,
						response.totals.w_25_44_total,
						response.totals.w_45_65_total,
						response.totals.m_18_24_total,
						response.totals.m_25_44_total,
						response.totals.m_45_65_total,
						response.totals.w_out_range_total,
						response.totals.m_out_range_total,
						response.totals.w_total,
						response.totals.m_total,
						response.totals.count,
					)

					list.push(totals);

					this.setState({
						listado: list,
						count:response.count,
						//totales:totals
					});

					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
				
						
					this.props.waiting.handleClose();
				}
				});		
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: 'all',//sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{t('sidebar.nav.reports.donor_age_gender')}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_donors_age_gender"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Tipo</span>
									<select className="form-control" name="type" id="type"
										value={this.state.type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="ACCEPT">ACEPTADOS</option>
										<option value="REJECT">RECHAZADOS GENERAL</option>
										<option value="GROUP_REJECT">RECHAZADOS AGRUPADOS</option>
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											Donantes Edad y Género
										</span>
									</div>
									<div className="col-xs-12">
										<span>
											Información Del:   <Moment format="DD/MM/YYYY">{this.state.start_date}</Moment>      
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: <Moment format="DD/MM/YYYY">{this.state.end_date}</Moment> 
										</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="col-xs-12">
										{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== "" ?
											<span>
												Lugar de Colecta:  
												<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
											</span>	
										:null}

										{this.state.type !== 'all' && this.state.type !== "" ?
											<span style={{marginLeft:"15px"}}>
												Tipo:  
												<b style={{marginLeft:"5px"}}>{this.state.type_name}</b>
											</span>	
										:null}
									</div>
								</div>

								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards"  id="table-to-xls" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								 {/*<div className="col-xs-12" style={{fontSize:"14px"}}>
									<table className="table">
										<tbody>
											<tr >
											{this.state.totales.map((t, i)=>{
												return <td key={i} style={
													this.state.type === 'REJECT' ?
														i===0 ? {width:'25%', textAlign:'right', paddingRight:'10px'} :
														i===5 ? {width:'11%'} : 
														i===4 ? {width:'9%'} :
														i===1 ? {width:'8%'} :
														{width:'10%'}
													:this.state.type === 'ACCEPT' ?
														i===0 ? {width:'18%'} :
														i===2 ? {width:'12.5%'} :
														i===3 ? {width:'12%'} :
														i===7 ? {width:'11%'} :
														{width:'13%'} 
													: i===2 ? {width:'11.5%'} : 
                                                      i===4 || i === 5 ? {width:'12%'} :
                                                      {width:'11%'}}
												><b>{t}</b></td>											
											})}
											</tr>
										</tbody>
									</table>
								</div>*/}
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}
export default translate('translations')(DonorAgeGender)